import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
} from "react-router-dom";
import Footer from "./components/home/Footer/Footer";
import Header from "./components/home/Header/Header";
import About from "./pages/About/About";
import SignIn from "./pages/Account/SignIn";
import SignUp from "./pages/Account/SignUp";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Shop from "./pages/Shop/Shop";
import "./styles/global.css";
import TermsConditions from "./pages/CompanyPolicy/TermsConditions";
import ShippingPolicy from "./pages/CompanyPolicy/ShippingPolicy";
import ReturnAndExchange from "./pages/CompanyPolicy/ReturnAndExchange";
import PrivacyPolicy from "./pages/CompanyPolicy/PrivacyPolicy";
import Profile from "./components/Profile/Profile";
import Orders from "./components/Orders/Orders";
import ForgotPassword from "./pages/Account/ForgotPassword";
import VerifyOtp from "./pages/Account/VerifyOtp";
import NewPassword from "./pages/Account/NewPassword";
import { GoogleOAuthProvider } from "@react-oauth/google";
import VerifysignupOtp from "./pages/Account/VerifysignupOtp";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  initializeCart,
  setProfileLoading,
  setUserInfo,
  toggleAuthentication,
} from "./redux/hejalSlice";
import Cookies from "js-cookie";
import ApiService from "./service/ApiService";
import { apiPaths } from "./service/apiPaths";
import { initializeWishlist, ToggleWishlist } from "./redux/wishlistSlice";
import WishList from "./components/WishList/WishList";
import Cart from "./pages/Shop/Cart";
import Checkout from "./pages/Shop/Checkout";
import { Offers } from "./pages/Offers/offers";
import PublicRoute from "./components/Routing/PublicRoute";
import PrivateRoute from "./components/Routing/PrivateRoute";
import UserVerify from "./pages/Account/UserVerify";
import DProducts from "./pages/DProducts/DProducts";
import NewArrivals from "./pages/New Arrivals/New Arrivals";
import Luggage from "./pages/Luggage/Luggage";
import Backpacks from "./pages/Backpack/Backpack";

const RetailerLayout = () => {
  const token = Cookies.get("accessToken");
  const dispatch = useDispatch();
  const { userInfo, isLoggedIn } = useSelector((state) => state.hejal);

  const getProfile = async () => {
    try {
      const data = await ApiService({
        method: "GET",
        endpoint: apiPaths.getProfile,
      });

      dispatch(setUserInfo(data?.data));
      dispatch(initializeCart(data?.data?.cart));
      dispatch(initializeWishlist(data?.data?.wishlist));
    } catch (error) {
      console.log("error while getting profile", error.message);
    } finally {
      dispatch(setProfileLoading(false));
    }
  };

  useEffect(() => {
    if (token && !isLoggedIn) {
      dispatch(toggleAuthentication());
    }
    if (token && !userInfo) {
      getProfile();
    } else {
      dispatch(setProfileLoading(false));
    }
    // eslint-disable-next-line
  }, [token]);

  return (
    <div>
      <Header />
      <ScrollRestoration />
      <Outlet />
      <Footer />
    </div>
  );
};

const WholesalerLayout = () => {
  const token = Cookies.get("accessToken");
  const dispatch = useDispatch();
  const { userInfo, isLoggedIn } = useSelector((state) => state.hejal);

  const getProfile = async () => {
    try {
      const data = await ApiService({
        method: "GET",
        endpoint: apiPaths.getProfile,
      });

      dispatch(setUserInfo(data?.data));
      dispatch(initializeCart(data?.data?.cart));
      dispatch(initializeWishlist(data?.data?.wishlist));
      // console.log("wishlist ",data?.data?.wishlist);
    } catch (error) {
      console.log("error while getting profile", error.message);
    } finally {
      dispatch(setProfileLoading(false));
    }
  };

  useEffect(() => {
    if (token && !isLoggedIn) {
      dispatch(toggleAuthentication());
    }
    if (token && !userInfo) {
      getProfile();
    } else {
      dispatch(setProfileLoading(false));
    }
    // eslint-disable-next-line
  }, [token]);

  return (
    <div>
      <ScrollRestoration />
      <Outlet />
      <Footer /> {/* Create this component */}
    </div>
  );
};
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* Public Routes (Only accessible when logged out) */}
      <Route element={<PublicRoute />}>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/verifyotp" element={<VerifyOtp />} />
        <Route path="/newpassword" element={<NewPassword />} />
        <Route path="/verification" element={<VerifysignupOtp />} />
        <Route path="/userverify" element={<UserVerify />} />
      </Route>

      {/* Private Routes (Only accessible when logged in) */}
      <Route
        element={
          <RetailerLayout>
            <PrivateRoute />
          </RetailerLayout>
        }
      >
        <Route path="/profile" element={<Profile />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/wishlist" element={<WishList />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/offers" element={<Offers />} />
      </Route>

      {/* General Routes (Accessible by everyone) */}
      <Route path="/" element={<RetailerLayout />}>
        <Route index element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/new-arrivals" element={<NewArrivals />} />
        <Route path="/luggage" element={<Luggage />} />
        <Route path="/backpacks" element={<Backpacks />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/product/:productId" element={<ProductDetails />} />
        <Route path="/termscondition" element={<TermsConditions />} />
        <Route path="/shippingpolicy" element={<ShippingPolicy />} />
        <Route path="/returnandexchange" element={<ReturnAndExchange />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        {/* <Route path="/wholesaler" element={<Wholesaler />} /> */}
        <Route path="/bags" element={<DProducts />} />
      </Route>
    </Route>
  )
);

function App() {
  return (
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
      key={"google123"}
    >
      <div className="font-bodyFont">
        <RouterProvider router={router} />
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;
